import CP1 from "../images/practices/CP1r.jpeg";
import CP2 from "../images/practices/CP2r.jpeg";
import CP3 from "../images/practices/CP3_3Ar.jpeg";
import CP3A from "../images/practices/CP3_3Ar.jpeg";
import CP4D from "../images/practices/CP4Dr.jpeg";
import CP5A from "../images/practices/CP5Ar.jpeg";
import CP8A from "../images/practices/CP8Ar.jpeg";
import CP9 from "../images/practices/CP9r.jpeg";
import CP12 from "../images/practices/CP12r.jpeg";
import CP15A from "../images/practices/CP15Ar.jpeg";
import CP16A from "../images/practices/CP16Ar.jpeg";
import CP17A from "../images/practices/CP17Ar.jpeg";
import CP18B from "../images/practices/CP18B_Cr.jpeg";
import CP18C from "../images/practices/CP18B_Cr.jpeg";
import CP21 from "../images/practices/CP21r.jpeg";
import CP22 from "../images/practices/CP22r.jpeg";
import CP23A from "../images/practices/CP23Ar.jpeg";
import CP23 from "../images/practices/CP23r.jpeg";
import CP25 from "../images/practices/CP25r.jpeg";
import CP27 from "../images/practices/CP27_28r.jpeg";
import CP28 from "../images/practices/CP27_28r.jpeg";
import CP29 from "../images/practices/CP29r.jpeg";
import CP30 from "../images/practices/CP30r.jpeg";
import CP31 from "../images/practices/CP31r.jpeg";
import CP33 from "../images/practices/CP33r.jpeg";
import CP36 from "../images/practices/CP36r.jpeg";
import CP37 from "../images/practices/CP37r.jpeg";
import CP38 from "../images/practices/CP38r.jpeg";
import CP39 from "../images/practices/CP39r.jpeg";
import CP40 from "../images/practices/CP40r.jpeg";
import CP42 from "../images/practices/CP42r.jpeg";
import CP43 from "../images/practices/CP43r.jpeg";
import CP88 from "../images/practices/CP88r.png";

const practiceImages = {
  CP1: CP1,
  CP2: CP2,
  CP3: CP3,
  CP3A: CP3A,
  CP4D: CP4D,
  CP5A: CP5A,
  CP8A: CP8A,
  CP9: CP9,
  CP12: CP12,
  CP15A: CP15A,
  CP15B: CP15A,
  CP16A: CP16A,
  CP17A: CP17A,
  CP18B: CP18B,
  CP18C: CP18C,
  CP21: CP21,
  CP22: CP22,
  CP23A: CP23A,
  CP23: CP23,
  CP25: CP25,
  CP27: CP27,
  CP28: CP28,
  CP29: CP29,
  CP30: CP30,
  CP31: CP31,
  CP33: CP33,
  CP36: CP36,
  CP37: CP37,
  CP38: CP38,
  CP39: CP39,
  CP40: CP40,
  CP41: CP40,
  CP42: CP42,
  CP43: CP43,
  CP88: CP88,
};

export default practiceImages;
